import {
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_SINGLE_GIFT_CARD,
    GET_ALL_USED_GIFT_CARDS,
    GET_ALL_GIFT_CARDS,
} from './giftTypes'
export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_ALL_GIFT_CARDS:
            return {
                ...state,
                search_allgiftcards: action.payload,
            }
        case GET_SINGLE_GIFT_CARD:
            return {
                ...state,
                search_single_giftcard: action.payload,
            }
        case GET_ALL_USED_GIFT_CARDS:
            return {
                ...state,
                search_allused_giftcards: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
